import React from "react";
import { cn } from "../lib/utils";
import { stageBadgeStyle } from "../lib/taskStage";

// The task's timeline stage, the same badge on every page. The backend resolves
// it into task.resolved_stage; the color is the one set in /settings/timelines.
//
// Usage:
//   <TaskStageBadge task={task} />
//   <TaskStageBadge task={task} size="sm" />
export default function TaskStageBadge({ task, size = "md", className = "" }) {
  const resolved = task?.resolved_stage;
  if (!resolved) return null;

  const sizeCls =
    size === "sm" ? "px-1.5 py-0 text-[10px] h-5"
    : size === "lg" ? "px-3 py-1 text-sm"
    : "px-2 py-0.5 text-xs";

  return (
    <span
      className={cn("inline-flex items-center rounded-md border font-medium whitespace-nowrap", sizeCls, className)}
      style={stageBadgeStyle(resolved.color)}
      title={resolved.stage_count ? `${resolved.name} · stage ${resolved.stage_index + 1} of ${resolved.stage_count}` : resolved.name}
      data-stage-id={resolved.stage_id}
    >
      {resolved.name}
    </span>
  );
}
